import apiClient from './apiClient';

/**
 * Event Vote API functions
 */
export const eventVoteApi = {
  /**
   * Get event vote data
   */
  getEventVote: async (eventId: string) => {
    try {
      console.log('Fetching event vote data from API...');
      const response = await apiClient.get(`/api/v2/web/events/${eventId}/vote`);
      console.log('Event vote API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getEventVote:', error);
      throw error;
    }
  },

  /**
   * Save event votes
   */
  saveEventVotes: async (eventId: string, votes: Array<{ selected_user_id: string; rank: number }>) => {
    try {
      console.log('Saving event votes...');
      const response = await apiClient.post(`/api/v2/web/events/${eventId}/vote`, { votes });
      console.log('Save votes API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in saveEventVotes:', error);
      throw error;
    }
  }
};
